/* MOEBE CRO v2. Only fixed feature names and random observation IDs leave this module. */
(() => {
  'use strict';
  if (window.MoebeCRO) return;
  const features = new Set(['wishlist','wishlist_sharing','predictive_search','search_languages','navigation','collection_sorting','lifestyle','sticky_cta','delivery','recommendations','usp','guarantee','empty_cart','shipping_progress','payment_reassurance','storage_configurator','sofa_configurator','shelving_configurator','retailers','resources']);
  const observations = new Map();
  const watched = new WeakMap();
  const visible = new Set();
  const preview = window.Shopify?.theme?.role !== 'main';
  let sequence = 0;
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const safe = fn => (...args) => { try { return fn(...args); } catch (_) { return undefined; } };
  const emit = (feature, stage, id) => {
    if (!allowed() || !features.has(feature) || !id || !window.Shopify?.analytics?.publish) return false;
    const result = window.Shopify.analytics.publish('moebe_cro_v2', {feature, stage, observation_id:id, preview});
    result?.catch?.(() => {});
    if (preview && document.body) {
      let panel = document.getElementById('MoebeCroQA');
      if (!panel) {
        panel = document.createElement('details'); panel.id = 'MoebeCroQA';
        panel.style.cssText = 'position:fixed;left:12px;bottom:70px;z-index:9999;background:white;color:#111;padding:10px;border:1px solid #aaa;max-height:240px;overflow:auto;font:12px monospace;max-width:340px';
        const summary = document.createElement('summary'); summary.textContent = 'CRO QA · published events (preview only)'; panel.append(summary); document.body.append(panel);
      }
      if (panel.childElementCount < 150) {const line=document.createElement('div');line.textContent=feature+' · '+stage;panel.append(line);}
    }
    return true;
  };
  function view(feature, restart = false) {
    if (!allowed() || !features.has(feature)) return;
    if (restart) observations.delete(feature);
    if (!observations.has(feature)) {
      const id = typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : Date.now().toString(36)+'_'+(++sequence)+'_'+Math.random().toString(36).slice(2);
      if (emit(feature, 'view', id)) observations.set(feature, {id, done:false});
    }
    return observations.get(feature)?.id;
  }
  function success(feature, id) {
    const observation = observations.get(feature);
    if (!observation || observation.done || (id && observation.id !== id)) return;
    if (emit(feature, 'success', observation.id)) observation.done = true;
  }
  function qualify(feature) {
    const observation = observations.get(feature);
    if (observation) emit(feature, 'qualify', observation.id);
  }
  const isVisible = el => {
    if (!el?.isConnected || el.closest('[hidden],[aria-hidden="true"]')) return false;
    const r = el.getBoundingClientRect();
    const style = getComputedStyle(el);
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth && style.visibility !== 'hidden' && style.display !== 'none' && style.opacity !== '0';
  };
  const io = new IntersectionObserver(entries => {
    entries.forEach(({target,isIntersecting}) => {
      if (isIntersecting) { visible.add(target); expose(target); }
      else visible.delete(target);
    });
  }, {threshold:0.1});
  function expose(el) {
    const item = watched.get(el);
    if (item && isVisible(el) && (!item.valid || item.valid())) {
      const id = view(item.feature);
      if (id) item.onView?.(id);
    }
  }
  function watch(el, feature, valid, onView) {
    if (!el || watched.has(el)) return;
    watched.set(el, {feature,valid,onView}); io.observe(el);
  }
  const all = (selector, feature, valid) => document.querySelectorAll(selector).forEach(el => watch(el, feature, valid && (() => valid(el))));
  let deliveryVariant = null;
  function scan() {
    all('.collection-content .grid-product', 'collection_sorting');
    all('.collection-content .moebe-card-pair[data-card-view="lifestyle"][data-lifestyle-ready] .grid-product__secondary-image', 'lifestyle', el => el.closest('[data-card-view="lifestyle"]'));
    all('moebe-sticky-purchase [data-buybar]', 'sticky_cta');
    all('.moebe-pairs:has(moebe-pair-purchase)', 'recommendations');
    all('[id$="__moebe_usp"] .rte', 'usp');
    all('moebe-garan-badge [data-garan-open]', 'guarantee');
    all('moebe-retailer-locator', 'retailers');
    all('moebe-pro-resources [data-pro-card]', 'resources');
    all('#NavDrawer moebe-mobile-menu', 'navigation', () => matchMedia('(max-width: 768px)').matches && document.getElementById('NavDrawer')?.classList.contains('drawer--is-open'));
    all('#CartDrawer .cart-empty-content', 'empty_cart', () => document.getElementById('CartDrawer')?.classList.contains('drawer--is-open'));
    all('.free-shipping-indicator:not(.is-qualified)', 'shipping_progress', el => !el.classList.contains('is-qualified'));
    all('.cart-drawer-payments', 'payment_reassurance');
    document.querySelectorAll('moebe-delivery-estimate [data-delivery-result]').forEach(el => watch(el, 'delivery', () => !el.hidden && !el.dataset.url && !!el.textContent.trim(), () => {
      const host = el.closest('moebe-delivery-estimate');
      deliveryVariant = document.getElementById(host.dataset.productForm)?.querySelector('[name="id"]')?.value || null;
    }));
    visible.forEach(el => { if (el.isConnected) expose(el); else visible.delete(el); });
  }
  function searchResults(host, translated) {
    const results = host.querySelector('[data-search-results]');
    observations.delete('predictive_search'); observations.delete('search_languages');
    if (!results || !isVisible(results)) return;
    const links = [...results.querySelectorAll('a[href]')].filter(a => /\/(products|collections)\//.test(a.pathname) && !a.classList.contains('moebe-search__view-all'));
    if (!links.length) return;
    const main = view('predictive_search', true);
    const local = translated ? view('search_languages', true) : null;
    links.forEach(a => a.addEventListener('click', () => {
      success('predictive_search', main);
      if (local) success('search_languages', local);
    }, {once:true}));
  }
  document.addEventListener('click', safe(event => {
    const a = event.target.closest('a[href]');
    if (!a) return;
    const discovery = /\/(products|collections)\//.test(a.pathname);
    if (discovery && a.closest('#NavDrawer moebe-mobile-menu')) success('navigation');
    if (discovery && a.closest('.collection-content .grid-product')) success('collection_sorting');
    const lifestyle = a.closest('.moebe-card-pair[data-card-view="lifestyle"][data-lifestyle-ready]');
    if (discovery && lifestyle && isVisible(lifestyle.querySelector('.grid-product__secondary-image'))) success('lifestyle');
    if (discovery && a.closest('#MoebeWishlist') && !document.querySelector('#MoebeWishlist [data-wishlist-shared]')?.hidden) success('wishlist_sharing');
    if (discovery && a.closest('#CartDrawer .cart-empty-content')) qualify('empty_cart');
    if (a.closest('moebe-retailer-locator [data-store]') && (/^(mailto:|tel:)/.test(a.href) || (a.protocol === 'https:' && a.hostname !== location.hostname && !/(^|\.)google\./.test(a.hostname)))) success('retailers');
    if (a.closest('moebe-pro-resources') && !a.hasAttribute('data-pro-guide') && (a.closest('.mpr-downloads') || a.matches('[data-pro-guide-link]')) && /^https?:$/.test(a.protocol)) success('resources');
  }), true);
  document.addEventListener('ajaxProduct:added', safe(event => {
    const product = event.detail?.product;
    // Compare the confirmed variant with the estimate that was actually seen.
    if (deliveryVariant && String(product?.variant_id || product?.id) === String(deliveryVariant)) success('delivery');
  }));
  window.MoebeCRO = Object.freeze({version:2, view:safe(view), success:safe(success), watch:safe(watch), searchResults:safe(searchResults)});
  let pending = false;
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(() => {pending = false; scan();}); } };
  const boot = () => {
    scan();
    new MutationObserver(schedule).observe(document.body, {subtree:true,childList:true,attributes:true,attributeFilter:['hidden','aria-hidden','class','open','data-card-view','data-lifestyle-ready']});
    document.addEventListener('visitorConsentCollected', () => { observations.clear(); deliveryVariant = null; schedule(); });
    document.addEventListener('visibilitychange', schedule);
    if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}], error => {if (!error) schedule();});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true}); else boot();
})();
